import { reactive, ref } from 'vue'
import { tablePrint } from '@/utils/print'
import { VxeTablePropTypes, VxeTableInstance } from 'vxe-table'
import $number from 'number-precision'
import $currency from 'currency.js'

export default function(props: any, dataMap: any) {
  const xTable = ref<VxeTableInstance>()
  const businessDetail = props.detail.details
    ? props.detail.details.map((item: any, index: any) => {
      return { ...item, index: ++index }
    })
    : []
  const mixinData = reactive({
    printDetail: {
      ...props.detail,
      details: businessDetail
    },
    tablePrint,
    mergeCells: [] as VxeTablePropTypes.MergeCell[],
    mergeFooterItems: [] as VxeTablePropTypes.MergeFooterItems
  })

  const printEvent1: () => void = () => {
    const $table = xTable.value as any
    const printObj = {
      isMerge: true,
      beforePrintMethod: ({ content }: any) => {
        // 拦截打印之前，返回自定义的 html 内容
        const part1 = document.getElementById('part1')
        const part2 = document.getElementById('part2')
        const header = part1 ? part1.innerHTML : ''
        const footer = part2 ? part2.innerHTML : ''
        return header + content + footer
      }
    }
    if (dataMap.printStyle) {
      Object.assign(printObj, { style: dataMap.printStyle })
    }
    try {
      $table.print(printObj)
    } catch (e) {
      console.error('Print Error:', e)
    }
  }

  const exportEvent = (type: string) => {
    const $table = xTable.value as any
    const exportObj = {
      filename: `报价单_${mixinData.printDetail.no}`,
      type,
      isMerge: true,
      beforeExportMethod: ({ content }: any) => {
        const part1 = document.getElementById('part1')
        const part2 = document.getElementById('part2')
        const header = part1 ? part1.innerHTML : ''
        const footer = part2 ? part2.innerHTML : ''
        return header + content + footer
      }
    }
    try {
      $table.exportData(exportObj)
    } catch (e) {
      console.error('Export Error:', e)
    }
  }

  // 乘法
  const numberTimes = (price: any, amount: any, isCurrency: boolean) => {
    const priceNum = price || 0
    const amountNum = amount || 0
    if (isCurrency) {
      return $currency($number.times(priceNum, amountNum))
    } else {
      return $number.times(priceNum, amountNum)
    }
  }

  // 加法
  const numberPlus = (price: any, amount: any, isCurrency: boolean) => {
    const priceNum = price || 0
    const amountNum = amount || 0
    if (isCurrency) {
      return $currency($number.plus(priceNum, amountNum))
    } else {
      return $number.plus(priceNum, amountNum)
    }
  }

  // 表格累加数据
  const sumNum = (list: any[], field: string, isCurrency: boolean) => {
    let count = 0 as any
    list.forEach(item => {
      count = numberPlus(count, item[field], false)
    })
    if (isCurrency) {
      return $currency(count)
    } else {
      return count
    }
  }
  const sumTotalNum = (list: any[], price: string, amount: string) => {
    let count = 0 as any
    list.forEach(item => {
      count = numberPlus(count, numberTimes(item[price], item[amount], false), false)
    })
    return $currency(count)
  }

  const getTaxRateLabel = (taxRate: any) => {
    return taxRate ? `含${taxRate}%的稅` : ''
  }
  const seqMethod = ({ seq }: any) => {
    return `NO.${seq}`
  }

  return { ...mixinData, printEvent1, exportEvent, sumNum, sumTotalNum, xTable, getTaxRateLabel, numberTimes, numberPlus, seqMethod }
}
